import { render, staticRenderFns } from "./TipsPage.vue?vue&type=template&id=b64e12c4&scoped=true&"
import script from "./TipsPage.vue?vue&type=script&lang=js&"
export * from "./TipsPage.vue?vue&type=script&lang=js&"
import style0 from "./TipsPage.vue?vue&type=style&index=0&id=b64e12c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64e12c4",
  null
  
)

export default component.exports